
import { defineComponent } from "vue";

import PostViewer from "./PostViewer.vue";
import Spinner from "./Spinner.vue";

export default defineComponent({
  components: {
    PostViewer,
    Spinner,
  },
});
